// extracted by mini-css-extract-plugin
module.exports = {"linkLabel":"FooterColumn_linkLabel__CnK_O","column":"FooterColumn_column__sF69l"};